import { Tooltip } from "@/components/ui";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils/cn";
import { OrganizationSwitcher, useOrganization } from "@clerk/react";
import React from "react";

export const OrgSwitcher: React.FC = () => {
  const { organization } = useOrganization();
  const { state } = useSidebar();
  const expanded = state === "expanded";

  return (
    <Tooltip delayDuration={0}>
      <Tooltip.Trigger
        render={
          <div className={expanded ? "w-full" : "w-auto"} data-prevent-sidebar-expand>
            <OrganizationSwitcher
              hidePersonal
              afterSelectOrganizationUrl="/"
              appearance={{
                elements: {
                  rootBox: "!w-full",
                  organizationSwitcherTrigger: cn(
                    "rounded-sm bg-primary/10 hover:bg-primary/20 transition-colors focus:outline-none focus:ring-2 focus:ring-primary/50 border-0",
                    expanded
                      ? "h-9 !w-full px-2 !justify-start items-center text-left"
                      : "size-9 p-0 mx-auto flex items-center justify-center gap-0 overflow-hidden",
                  ),
                  organizationSwitcherTriggerIcon: "hidden",
                  organizationSwitcherTrigger__organizationPreview: expanded
                    ? "flex w-full items-center justify-start"
                    : "inline-flex items-center justify-center w-full",
                  organizationSwitcherTrigger__organizationPreviewAvatarContainer: expanded
                    ? "inline-flex items-center !justify-start"
                    : "inline-flex items-center justify-center mx-auto",
                  organizationSwitcherTrigger__organizationPreviewAvatarBox: expanded
                    ? "size-6"
                    : "size-9",
                  organizationSwitcherTrigger__organizationPreviewAvatarImage: expanded
                    ? "w-6 h-6 object-cover"
                    : "w-9 h-9 object-cover",
                  organizationSwitcherTrigger__organizationPreviewTextContainer: expanded
                    ? "flex min-w-0 items-center justify-start text-left"
                    : "hidden w-0 p-0 m-0 overflow-hidden",
                  organizationSwitcherTrigger__organizationPreviewMainIdentifier: expanded
                    ? "inline"
                    : "hidden",
                  organizationSwitcherTrigger__organizationPreviewSecondaryIdentifier: expanded
                    ? "inline"
                    : "hidden",
                  organizationSwitcherPopoverActionButton: "hidden",
                },
              }}
            />
          </div>
        }
      />

      {!expanded && (
        <Tooltip.Content side="right">
          <p>{organization?.name ?? "Organization"}</p>
        </Tooltip.Content>
      )}
    </Tooltip>
  );
};
